export default __webpack_public_path__ + "static/media/videociety-watermark.9754f20d.png";